import React, { Component } from 'react';
import NavMenu from './NavMenu';
import { withRouter } from 'react-router-dom';
import UserAuthentication from "../../ducks/UserAuthentication";
import Users from "../../ducks/Users";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import "./Layout.css";
import Notifications from '../notifications/index';
import camera from "../../assets/img/ic_camera.png"
import { Modal, ModalHeader, ModalBody,ModalFooter, DropdownItem, DropdownMenu, DropdownToggle, 
  UncontrolledDropdown, } from 'reactstrap';

class Layout extends Component {

  constructor() {
    super();
    this.state = {
      popoverOpen: false,
      user : {}
    }
  }

  logoutUser = async () => {
    await this
      .props
      .authActions
      .logoutUser();
    this
      .props
      .history
      .push("/login");
  };
  nevigate = async (value) => {
    this
      .props
      .history
      .push(value);
  };

  componentDidMount(){
    let user = JSON.parse(localStorage.getItem('user'));
    this.setState({...this.state, user:user});
  }

  render() {
    const groupInfo = this.props.loggedInGroupInfo;
    const isSuperAdminUser = localStorage.getItem('isSuperAdminUser');

    return (

      <>

      <div className="container-fluid">
        <div className="row content-whole">
          <NavMenu/>
          <main className={"col-md-10 col-sm-9 ml-sm-auto pt-3 content"}>
            <header className="header">
              <nav className="navbar navbar-expand-md">
                <a
                  className="navbar-toggler d-lg-none"
                  data-toggle="collapse"
                  aria-expanded="false"
                  aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"/>
                </a>

                <div className="collapse navbar-collapse ">
               
                  <div className="header-section mt-2 mt-md-0 ml-auto">
                 
                    <Notifications/> 
                    <img
                      src={groupInfo
                        ? groupInfo.groupImage || camera
                        : camera}
                      alt="group"
                      onClick={this.nevigate.bind(this, '/account')}
                      className='group-header-image'/>
                  </div>
                
                  <div className="dropdown">
                    <UncontrolledDropdown nav inNavbar>
                      <DropdownToggle nav caret className=" header-group-name">
                        {this.state?.user?.user?.name}
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem onClick={this.nevigate.bind(this, '/help')}>
                          <a>Help</a>
                        </DropdownItem>
                        <DropdownItem onClick={this.nevigate.bind(this, '/aboutus')}>
                          <a>About Us</a>
                        </DropdownItem>
                     
                        <DropdownItem onClick={this.nevigate.bind(this, '/account')}>
                          <a>Account</a>
                        </DropdownItem>
                       
                        <DropdownItem onClick={this.nevigate.bind(this, '/users')}>
                          <a>Users</a>
                        </DropdownItem>
                        
                        
                        <DropdownItem onClick={this.logoutUser}>
                          <a>Logout</a>
                        </DropdownItem>

                      </DropdownMenu>
                    </UncontrolledDropdown>

                  </div>
                </div>
              </nav>
            </header>
            {this.props.children}
          </main>
        </div>
      </div>
      
      </>
    )
  }
}

Layout.propTypes = {};
Layout.defaultProps = {};
const mapStateToProps = state => ({ 
  loggedInGroupInfo: state.userAuthentication.loggedInGroupInfo, 
  message: state.users.message,
});

const mapDispatchToProps = dispatch => ({
  authActions: bindActionCreators(UserAuthentication.creators, dispatch),
  usersActions: bindActionCreators(Users.creators, dispatch),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));
